import React from 'react';
import { Modal } from '../../../components';

interface ArchiveProductModalProps {
  title: string;
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation for taking a product out of the store.
 *
 * Two things happen behind one button, and which one you get depends on
 * something the seller can't see from here, so the dialog says both: a product
 * that has been ordered is archived and its orders keep working, and one that
 * never sold is deleted outright. "Are you sure?" would have left the seller to
 * find out which afterwards.
 */
export const ArchiveProductModal: React.FC<ArchiveProductModalProps> = ({
  title,
  open,
  loading,
  onClose,
  onConfirm,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title="Archive this product?"
    icon="warning"
    size="small"
    footer
    loading={loading}
    primaryAction={{
      label: 'Archive product',
      variant: 'destructive',
      onClick: onConfirm,
      disabled: loading,
    }}
    secondaryActions={{ label: 'Cancel', variant: 'secondary', onClick: onClose }}
  >
    <div className="mt-4 space-y-3 text-sm text-muted-foreground">
      <p>
        <span className="font-medium text-foreground">{title}</span> comes off the store and stops
        selling.
      </p>
      <p>
        If it has ever been ordered it is archived, so those orders and their payouts keep working.
        If it has never been ordered it is deleted.
      </p>
    </div>
  </Modal>
);
